import { useMemo } from 'react';
import { CommanderFormContext, CommanderFormContextValues } from './CommanderFormContext';

interface FormContextProviderProps extends Partial<CommanderFormContextValues> {
    children: React.ReactNode;
}

export const CommanderFormProvider = ({ readOnlyForm = false, children }: FormContextProviderProps) => {
    const value = useMemo(
        () => ({
            readOnlyForm,
        }),
        [readOnlyForm]
    );

    return <CommanderFormContext.Provider value={value}>{children}</CommanderFormContext.Provider>;
};
